const NAMES: Record<string, string> = {
  AE: 'ОАЭ',
  AM: 'Армения',
  AT: 'Австрия',
  AZ: 'Азербайджан',
  BA: 'Босния и Герцеговина',
  BH: 'Бахрейн',
  BY: 'Беларусь',
  CN: 'Китай',
  CY: 'Кипр',
  CZ: 'Чехия',
  DE: 'Германия',
  ES: 'Испания',
  FR: 'Франция',
  GE: 'Грузия',
  GR: 'Греция',
  HU: 'Венгрия',
  ID: 'Индонезия',
  IL: 'Израиль',
  IN: 'Индия',
  IT: 'Италия',
  JO: 'Иордания',
  JP: 'Япония',
  KG: 'Киргизия',
  KR: 'Южная Корея',
  KZ: 'Казахстан',
  LK: 'Шри-Ланка',
  LV: 'Латвия',
  MD: 'Молдова',
  ME: 'Черногория',
  MY: 'Малайзия',
  NL: 'Нидерланды',
  PH: 'Филиппины',
  PL: 'Польша',
  QA: 'Катар',
  RS: 'Сербия',
  RU: 'Россия',
  SE: 'Швеция',
  SG: 'Сингапур',
  TH: 'Таиланд',
  TJ: 'Таджикистан',
  TM: 'Туркменистан',
  TR: 'Турция',
  UA: 'Украина',
  US: 'США',
  UZ: 'Узбекистан',
  VN: 'Вьетнам',
};

let regionNames: Intl.DisplayNames | null = null;
try {
  regionNames = new Intl.DisplayNames(['ru'], { type: 'region' });
} catch {
  // Старый WebView без Intl.DisplayNames — остаются названия из словаря выше.
}

export function countryName(code: string): string {
  const upper = code.toUpperCase();
  return NAMES[upper] ?? regionNames?.of(upper) ?? upper;
}

const FLAGS = import.meta.glob<string>('@flags/*.svg', {
  query: '?no-inline',
  import: 'default',
  eager: true,
});
const FLAG_BY_CODE = new Map(
  Object.entries(FLAGS).map(([path, url]) => [path.slice(-6, -4).toUpperCase(), url]),
);

/** Пустая строка — флага нет; картинку тогда не показываем. */
export function countryFlagUrl(code: string): string {
  return FLAG_BY_CODE.get(code.trim().toUpperCase()) ?? '';
}
